export default __webpack_public_path__ + "static/media/p2023-38.f8fbdced.jpeg";